/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";
import debounce from "lodash.debounce";
// import useFieldZone from 'cms/fields/context/use-field-zone'
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
// import useThrottle from 'hooks/useThrottle'
import useStyles from "cms/fields/_styles";
import { SettingsStyleEdit } from "cms/fields/layout/controls/settings-style";
import DisplaySettingsWrapper from "cms/fields/layout/display-settings-wrapper";
import { useSelectFieldSchema } from "cms/fields/dynamic-field";

const DecimalFieldItemEdit = () => {
    
    // const { localState } = props
    // const throttler = useThrottle()
    
    const { t } = useTranslation();
    const classes = useStyles();
    const ctx = useContext(ListItemContext);
    const { type, name, index, value, settings, updateListItem, disabled = false } = ctx;

    const schema = useSelectFieldSchema(name);
    const { settings: schemaSettings } = schema || {};
    const { styleOptions, placeholder } = schemaSettings || {};

    const ph = placeholder || t("commons.placeholderText");

    const [itemLocalState, setItemLocalState] = useState({ value, settings });
    
    // const update = () => {
    //     updateListItem(itemLocalState, index)
    // }
    // useEffect(() => {
    //     throttler(update)
    // }, [itemLocalState])
    //
    // useEffect(() => {
    //     setItemLocalState({ value, settings })
    // }, [value, settings])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((updateState, index) => {
            updateListItem(updateState, index);
        }, 1200),
        [updateListItem]
    );
    const onSettingsChange = (updateState) => {
        setItemLocalState(updateState);
        update(updateState, index);
    };

    const onChange = (event) => {
        const newValue = event.target.value;
        const updateState = {
            ...itemLocalState,
            value: newValue
        };
        setItemLocalState(updateState);
        update(updateState, index);
    };

    return (
        <Fragment>
            <div className='simplicity-composer-field-primary-layout'>
                <div className='simplicity-composer-field-primary'>
                    <TextField
                        className={disabled ? classes.disabled : ""}
                        fullWidth={true}
                        placeholder={ph}
                        value={Number(itemLocalState?.value)}
                        disabled={disabled}
                        variant='standard'
                        type='number'
                        onChange={onChange}
                    />
                </div>
                <DisplaySettingsWrapper>
                    {/*  Reads from schema options.styleOptions */}
                    {/*  records selection as value settings.style */}
                    <SettingsStyleEdit
                        type={type}
                        name={name}
                        label={t("commons.displayStyle")}
                        itemLocalState={itemLocalState}
                        setItemLocalState={setItemLocalState}
                        disabled={disabled}
                        styleOptions={styleOptions}
                        selected={itemLocalState?.settings?.style}
                        index={index}
                        update={onSettingsChange}
                    />
                </DisplaySettingsWrapper>
            </div>
        </Fragment>
    );
};
DecimalFieldItemEdit.displayName = "DecimalFieldItemEdit";
export { DecimalFieldItemEdit };
